import { combineReducers, createStore } from "redux";

const rootReducer = combineReducers({
  checktoken_data: {},
});

const store = createStore(rootReducer);

export default store;
